import { EditorialRelatedContentBlock } from 'App/Epi/Blocks'
import { EditorialArticleListItemProps } from 'App/Epi/Blocks/EditorialRelatedContentBlock/EditorialRelatedContentBlock'
import { useTranslation } from 'react-i18next'

export interface RelatedContentProps {
  heading: string
  body: string
  url: string
  date?: string
  category?: string
  pageType: string
  image?: string
}
export interface RelatedContentProp {
  relatedContent: RelatedContentProps[]
  fallbackImage: string
}

const RelatedContent = ({
  relatedContent,
  fallbackImage,
}: RelatedContentProp) => {
  const { t } = useTranslation()
  return (
    <EditorialRelatedContentBlock
      content={{
        heading: t('translation:relatedContent.title'),
        fallbackImage: fallbackImage,
        articleListItems: relatedContent.map(RelatedContentPropsMapper),
      }}
    />
  )
}

const RelatedContentPropsMapper = (
  inProps: RelatedContentProps
): EditorialArticleListItemProps => {
  return {
    properties: {
      articleCategory: inProps.category || '',
      pageType: inProps.pageType,
      image: inProps.image || '',
      heading: inProps.heading,
      preamble: inProps.body,
      startPublish: inProps.date || '',
      url: inProps.url,
    },
  }
}

export default RelatedContent
